<div class="page-container login-container has-footer">
  <h1>Welcome to Table Flip Games!</h1>
  <p>Please create a name that your friends can identify you by and enter the code shown on the main screen.</p>

  <mat-form-field class="full-width">
    <input matInput placeholder="Favorite food" [(ngModel)]="name" type="text" placeholder="Player Name">
  </mat-form-field>

  <mat-form-field class="full-width">
    <input matInput [(ngModel)]="gameId" type="text" class="room-code" placeholder="Room Code">
  </mat-form-field>

  <small *ngIf="gameExistsError" class="error">This game code does not exist, please double check and try again.</small>

</div>

<div class="footer-bar-container">
  <div class="footer-bar-content">
    <button mat-raised-button color="primary" class="full-width" (click)="submit()">Login</button>
  </div>
</div>
